module.exports = __webpack_public_path__ + "assets/svg/Icons/32/task-gray-48bcc1.svg";